var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5113,
    cy: 5.68419,
    r: 5.68419,
    fill: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90211 20.89C2.72709 16.3223 6.7032 13 11.3448 13C15.9706 13 19.938 16.3004 20.7799 20.8491L21.4932 24.7026C22.14 28.197 19.4576 31.4213 15.9039 31.4213H6.8028C3.2591 31.4213 0.579268 28.2141 1.20912 24.7268L1.90211 20.89Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3271 8C30.3271 6.89543 29.4317 6 28.3271 6C27.2226 6 26.3271 6.89543 26.3271 8V13H21.8271C20.7226 13 19.8271 13.8954 19.8271 15C19.8271 16.1046 20.7226 17 21.8271 17H26.3271V21.5C26.3271 22.6046 27.2226 23.5 28.3271 23.5C29.4317 23.5 30.3271 22.6046 30.3271 21.5V17H34.8271C35.9317 17 36.8271 16.1046 36.8271 15C36.8271 13.8954 35.9317 13 34.8271 13H30.3271V8Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/Staff.777fa28f7c27b6058dd0e2db9b31d2af.svg";
export { ForwardRef as ReactComponent };